import { GridRowParams } from '@material-ui/data-grid';
import React, { ChangeEvent, useCallback, useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { toast } from 'react-toastify';
import Search from '~/components/Search';
import { getUserData } from '~/services/user';
import ToggleDefault from '~/components/ToggleDefault';
import { Container } from './styles';
import api from '~/services/api';
import FormDefault from '~/components/FormDefault';
import Loja from '~/components/Loja';
import {
  BuscaParceiro,
  InputAsyncSelect,
  InputNumber2,
  InputText,
} from '~/components/NovosInputs';
import { useForm } from 'react-hook-form';
import Separator from '~/components/Separator';
import { yupResolver } from '@hookform/resolvers/yup';
import { schemaOperador } from './validations/validation';
import DefaultLoader from '~/components/DefaultLoader';

const MySwal = withReactContent(Swal);

const Operador: React.FC = () => {
  const {
    register,
    control,
    reset,
    getValues,
    setValue,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemaOperador),
  });

  const user = getUserData();
  /**
   * Adicionar tipagem a todos os objetos da tela
   */
  const [loader, setLoader] = useState<boolean>(false);
  const [inativo, setInativo] = useState<boolean>(false);
  const [isInvalidLoja, setIsInvalidLoja] = useState<boolean>(false);
  const [isUpdate, setUpdate] = useState<boolean>(false);
  const [showSearch, setShowSearch] = useState<boolean>(true);
  const [lojas, setLojas] = useState<number | number[]>(user.loja);

  /**
   * Reseta form para criação de novo registro
   */
  const resetFormData = useCallback(() => {
    setUpdate(false);
    setLojas(user.loja);
    setIsInvalidLoja(false);
    clearErrors();
    reset({
      cod_operador: '',
      des_operador: '',
      busca_parceiro: '',
      finalizadora: '',
      cod_perfil: { label: 'Selecione', value: null },
    });

    setInativo(false);
  }, [user.loja]);

  /**
   * Evento disparado ao clicar em uma linha da tabela
   * @param param
   */
  const onRowClick = async (param: GridRowParams) => {
    const { row } = param;
    const {
      cod_finalizadora,
      des_finalizadora_view,
      cod_pessoa,
      des_cliente,
      des_operador,
      cod_operador,
      cod_loja,
      flg_inativo,
      num_cpf_cnpj,
      cod_perfil,
      des_perfil,
      flg_gera_financeiro,
    } = row;
    if (!cod_finalizadora) {
      setValue('finalizadora', '');
    } else {
      setValue('finalizadora', {
        label: des_finalizadora_view,
        cod_finalizadora,
      });
    }
    const labelText = num_cpf_cnpj ? `(${num_cpf_cnpj})` : '';
    setValue('busca_parceiro', {
      cod_pessoa,
      value: cod_pessoa,
      label: `${cod_pessoa} - ${des_cliente} ${labelText}`,
    });
    setValue('des_operador', des_operador);
    setValue('cod_operador', cod_operador);
    setValue('cod_perfil', {
      value: cod_perfil,
      label: cod_perfil
        ? `${cod_perfil} - ${des_perfil}`
        : 'Nenhum perfil selecionado',
      flg_gera_financeiro: flg_gera_financeiro || false,
    });
    setUpdate(true);
    setLojas(cod_loja);

    setInativo(flg_inativo);

    setLoader(false);

    setShowSearch(false);
  };
  /**
   * Evento reponsavel por cadastrar ou editar um Operador
   * @return
   */
  const onSubmit = handleSubmit(async (dataForm) => {
    const { cod_perfil } = dataForm;
    try {
      const operador = getValues('des_operador');
      if (
        operador.trim() === 'NENHUM' ||
        operador.trim() === 'NENHUMA' ||
        operador.trim() === 'NENHUM(A)'
      ) {
        return toast.warn(
          'Descrição contém palavra não permitida "Nenhum/Nenhuma".',
        );
      }
      if (isUpdate) {
        const { data } = await api.put(
          `/operador/${getValues('cod_operador')}`,
          {
            cod_loja: lojas,
            cod_finalizadora: getValues('finalizadora').cod_finalizadora,
            tipo_operador: 0,
            cod_operador: getValues('cod_operador'),
            flg_inativo: inativo,
            cod_pessoa: getValues('busca_parceiro').cod_pessoa,
            des_operador: getValues('des_operador').trim(),
            cod_perfil: cod_perfil ? cod_perfil.value : null,
          },
        );

        if (data.success) {
          toast.success(data.message);
          resetFormData();
          setShowSearch(true);
        }

        setLoader(false);

        return;
      }
      const { data } = await api.post('/operador', {
        cod_loja: lojas,
        cod_finalizadora: getValues('finalizadora').cod_finalizadora,
        tipo_operador: 0,
        cod_operador: getValues('cod_operador'),
        flg_inativo: inativo,
        cod_pessoa: getValues('busca_parceiro').cod_pessoa,
        des_operador: getValues('des_operador').trim(),
        cod_perfil: cod_perfil ? cod_perfil.value : null,
      });

      if (data.success) {
        toast.success(data.message);
        resetFormData();
      }
    } finally {
      setLoader(false);
    }
  });

  /**
   * Inativa um caixa
   */

  const handleChangeLoja = useCallback(
    (val) => {
      setIsInvalidLoja(false);
      if (lojas !== val && !isUpdate) setValue('finalizadora', null);
      setLojas(val);
    },
    [isUpdate, lojas, setValue],
  );

  if (loader) {
    return <DefaultLoader />;
  }

  return (
    <Container>
      {showSearch && (
        <Search
          codTela={14}
          newData={() => setShowSearch(false)}
          onRowClick={onRowClick}
        />
      )}

      {!showSearch && (
        <FormDefault
          codTela={14}
          title="Cadastro de Operador de Caixa"
          onSave={async () => {
            await onSubmit();
          }}
          codigoRegistro={[
            {
              value: getValues('cod_operador'),
              des_campo: 'Código do Registro',
            },
          ]}
          onCancel={() => {
            resetFormData();
            setShowSearch(true);
          }}
          isDelete={false}
          isUpdate={isUpdate}
          onNew={resetFormData}
          onDelete={() => []}
          onClearFields={resetFormData}
          onReturnSearch={() => {
            setShowSearch(true);
            setUpdate(false);
            resetFormData();
          }}
        >
          <div className="row">
            <div
              className="col-sm-12 col-md-12"
              style={{ zIndex: 3, marginTop: '10px' }}
            >
              <Loja
                selectedLoja={lojas}
                onChange={(val) => handleChangeLoja(val)}
                isDisabled={isUpdate}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-2">
              <InputNumber2
                name="cod_operador"
                label="Código"
                disabled={isUpdate}
                placeholder="0"
                register={register}
                control={control}
                isError={!!errors.cod_operador}
                maxLength={9}
                max={99999}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  if (e.target.value.length < 9) {
                    clearErrors('cod_operador');
                    setValue('cod_operador', Math.abs(Number(e.target.value)));
                  }
                }}
              />
            </div>
            <div className="col-md-12 col-lg-8 col-xl-9">
              <InputText
                name="des_operador"
                label="Descrição Tesouraria"
                placeholder="Informe a Descrição"
                register={register}
                control={control}
                isError={!!errors.des_operador}
                maxLength={25}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  const value = e.target.value.trimStart();
                  clearErrors('des_operador');
                  setValue('des_operador', value.toUpperCase());
                }}
              />
            </div>
            <div
              className="col-md-12 col-lg-1 col-xl-1"
              style={{ marginTop: '0.67em' }}
            >
              <div className="toggle">
                <ToggleDefault
                  labelText="Inativo?"
                  setChecked={inativo === true}
                  onSwitch={() => {
                    setInativo(!inativo);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <InputAsyncSelect
                label="Perfil para Venda"
                maxLength={50}
                listWidth="100%"
                placeholder="Selecione..."
                name="cod_perfil"
                register={register}
                isError={!!errors.cod_perfil}
                control={control}
                changeSelected={(selected: any) => {
                  clearErrors('cod_perfil');
                  setValue('cod_perfil', selected);
                }}
                title=""
                disabled={false}
                api={{
                  route: '/perfil-pedido-venda',
                  method: 'get',
                  fields: ['cod_perfil', 'des_perfil'],
                  searchBeforeFilter: true,
                }}
                includeNoneOption
              />
            </div>
          </div>

          <Separator labelText="Tesouraria" />
          <div className="row">
            <div
              className="col-sm-12 col-md-12 col-lg-9"
              style={{ marginTop: '10px' }}
            >
              <BuscaParceiro
                label="Cliente p/ Quebra"
                placeholder="Selecione..."
                name="busca_parceiro"
                register={register}
                isError={!!errors.busca_parceiro}
                control={control}
                customOptions={{
                  buscarPor: { cliente: true },
                }}
                changeSelected={(selected: any) => {
                  clearErrors('busca_parceiro');
                  setValue('busca_parceiro', selected);
                }}
              />
            </div>
            <div
              className="col-sm-12 col-md-12 col-lg-3"
              style={{ marginTop: '10px' }}
            >
              <InputAsyncSelect
                label="Finalizadora"
                maxLength={50}
                placeholder="Selecione..."
                name="finalizadora"
                register={register}
                isError={!!errors.finalizadora}
                control={control}
                changeSelected={(selected) => {
                  clearErrors('finalizadora');
                  setValue('finalizadora', selected);
                }}
                api={{
                  route: '/finalizadora/ativas',
                  method: 'get',
                  bodyParams: {
                    codLoja: lojas,
                  },
                  fields: ['cod_finalizadora', 'des_finalizadora'],
                  dependsOf: ['codLoja'],
                  messageForDependsOf: 'É necessário selecionar a loja',
                  searchBeforeFilter: true,
                }}
              />
            </div>
          </div>
        </FormDefault>
      )}
    </Container>
  );
};

export default Operador;
